(() => {
  if (window.hbCartNoteGlobalInitialized) return;
  window.hbCartNoteGlobalInitialized = true;

  const noteTimers = new WeakMap();

  function getCartUpdateUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/update.js`;
  }

  async function saveCartNote(textarea) {
    const root = textarea.closest('[data-hb-cart-note]');
    const status = root?.querySelector('[data-hb-cart-note-status]');

    if (status) {
      status.textContent = 'Salvataggio...';
    }

    try {
      const response = await fetch(getCartUpdateUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          note: textarea.value,
        }),
      });

      if (!response.ok) throw new Error('Errore salvataggio nota');

      if (status) {
        status.textContent = 'Nota salvata';

        setTimeout(() => {
          if (status.textContent === 'Nota salvata') {
            status.textContent = '';
          }
        }, 1800);
      }
    } catch (error) {
      console.warn(error);

      if (status) {
        status.textContent = 'Nota non salvata. Riprova.';
      }
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      const toggle = event.target.closest('[data-hb-cart-note-toggle]');
      if (!toggle) return;

      const root = toggle.closest('[data-hb-cart-note]');
      const content = root?.querySelector('[data-hb-cart-note-content]');
      const icon = root?.querySelector('.hb-cart-note__icon');

      if (!content) return;

      const isOpen = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      content.hidden = isOpen;

      if (icon) {
        icon.textContent = isOpen ? '+' : '−';
      }
    },
    true
  );

  document.addEventListener('input', function (event) {
    if (!(event.target instanceof Element)) return;

    const textarea = event.target.closest('[data-hb-cart-note-textarea]');
    if (!textarea) return;

    clearTimeout(noteTimers.get(textarea));

    const timer = setTimeout(() => {
      saveCartNote(textarea);
    }, 700);

    noteTimers.set(textarea, timer);
  });

  document.addEventListener(
    'blur',
    function (event) {
      if (!(event.target instanceof Element)) return;

      const textarea = event.target.closest('[data-hb-cart-note-textarea]');
      if (!textarea) return;

      clearTimeout(noteTimers.get(textarea));
      saveCartNote(textarea);
    },
    true
  );
})();